import React from 'react';

import type { IFormConsumerState } from './IFormConsumerState';

const initialContext: IFormConsumerState<unknown> = {
    formDisabled: false,
    formHasErrors: false,
    lang: 'no',
    formRef: { current: null },
    values: {},
};

export const FormContext =
    React.createContext<IFormConsumerState<unknown>>(initialContext);
